<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-06-06 14:56:55
 * @FilePath: \gcp-fe\src\app\shop\views\announcementsList.vue
 * @Description: 
-->
<template>
  <mallViewAllList
    v-if="source === '1' && type == 9"
    :currBreadCrumb="currBreadCrumb"
    :type="type"
  ></mallViewAllList>
  <noticeViewAllList
    v-else-if="source === '1' && type != 3"
    :currBreadCrumb="currBreadCrumb"
    :type="type"
  ></noticeViewAllList>
  <evaNoticeViewAllList
    v-else-if="source === '1' && type == 3"
    :currBreadCrumb="currBreadCrumb"
    :type="type"
  ></evaNoticeViewAllList>
  <list
    v-else
    :currBreadCrumb="currBreadCrumb"
    :callInterface="callInterface"
    :otherParams="otherParams"
  ></list>
</template>

<script>
import { queryPublishedNoticeList } from "@/app/shop/api/shoppingSP";
import list from "@/app/shop/components/list.vue";
import noticeViewAllList from "@/app/shop/components/noticeViewAllList.vue";
import mallViewAllList from "@/app/shop/components/mallViewAllList.vue";
import evaNoticeViewAllList from "@/app/shop/components/eva-noticeViewAllList.vue";
export default {
  name: "announcementsList",
  components: {
    list,
    noticeViewAllList,
    mallViewAllList,
    evaNoticeViewAllList
  },
  data() {
    return {
      currBreadCrumb: [{ title: "采购公告", path: "/procurementNotice" }],
      callInterface: queryPublishedNoticeList,
      otherParams: {
        module: 1,
        pageState: 2,
        appId: 100123
      },
      source: this.$route.query.source,
      type: this.$route.query.type
    };
  },
  activated() {
    // this.setBreadCrumb();
    if (this.source === "1") {
      switch (this.type) {
        case "3": //评标结果
          this.currBreadCrumb.push({
            title: "评标/评审结果公示"
          });
          break;
        case "4": //中标通知
          this.currBreadCrumb.push({
            title: "中标通知"
          });
          break;
        case "5": //中标通知
          this.currBreadCrumb.push({
            title: "中标通知"
          });
          break;
        case "7": //补遗公告
          this.currBreadCrumb.push({
            title: "补遗公告"
          });
          break;
        case "8": //流标公告
          this.currBreadCrumb.push({
            title: "流标公告"
          });
          break;
        case "9": //商城式订单采购公告
          this.currBreadCrumb = [{ title: "商城式订单采购公告" }];
          break;
      }
    } else {
      this.currBreadCrumb.push({
        title: "业务公告"
      });
    }
  },
  deactivated() {
    this.currBreadCrumb = [{ title: "采购公告", path: "/procurementNotice" }];
  },
  methods: {
    // setBreadCrumb() {
    //   const handlerClick = searchType => {
    //     const serchTypeMap = {
    //       首页: "",
    //       采购公告: "procurementNotice"
    //     };
    //     location.href = `${this.$addUrlPerFix(process.env.VUE_APP_JRW_URL)}/${
    //       serchTypeMap[searchType]
    //     }`;
    //   };
    //   const source = this.$route.query.searchType;
    //   if (this.$route.query.isJRZL === "1") {
    //     this.currBreadCrumb = [];
    //     this.currBreadCrumb.push({
    //       title: source,
    //       clickFn: this.$route.query.isJRZL === "1" ? handlerClick : null,
    //       to: "/"
    //     });
    //   }
    // },
    back() {
      const serchTypeMap = {
        首页: "",
        采购公告: "procurementNotice"
      };
      const searchType = this.$route.query.searchType;
      location.href = `${this.$addUrlPerFix(process.env.VUE_APP_JRW_URL)}/${
        serchTypeMap[searchType]
      }`;
    }
  }
};
</script>

<style scoped></style>
